import { Companies } from "./Companies";
import { Contacts } from "./IContacts";
import { Addresses } from "./IAdressess";
import { Documents } from "./IDocuments";
import { Persons } from "./IPersons";
import { PIX } from "./iPersonPixAddressKey";

export namespace BusinessUnits {
  export interface IBusinessUnit {
    id: number;
    companyDataId: number;
    companyData: Companies.ICompanyData;
    addressId: number;
    address: Addresses.IAddress;
    documents: Documents.IDocument[];
    contacts: Contacts.IContact[];
    businessUnitPersons?: Persons.IPerson[];
    status: number;
    distance: string;
    distanceValue: number;
    averageGrade: number;
    evaluationsCount: number;
    personId: number;
    businessUnitEvaluation: number;
    professionalsPaymentsAccountData?: IProfessionalsPaymentAccountData;
    pixAddressKey: PIX.IPixAddressKey;
  }

  export class BusinessUnit implements IBusinessUnit {
    id: number = 0;
    companyDataId: number = 0;
    companyData: Companies.ICompanyData = new Companies.CompanyData();
    addressId: number = 0;
    address: Addresses.IAddress = new Addresses.Address();
    documents: Documents.IDocument[] = new Array<Documents.IDocument>();
    contacts: Contacts.IContact[] = new Array<Contacts.IContact>();
    businessUnitPersons?: Persons.IPerson[] = new Array<Persons.IPerson>();
    status: number = 0;
    distance: string = "";
    distanceValue: number = 0;
    averageGrade: number = 0;
    evaluationsCount: number = 0;
    personId: number = 0;
    businessUnitEvaluation: number = 0;
    professionalsPaymentsAccountData?: IProfessionalsPaymentAccountData = new ProfessionalsPaymentAccountData();
    pixAddressKey: PIX.IPixAddressKey = new PIX.PixAddressKey();
  }

  export interface IUpdateBusinessUnitRequest {
    id: number;
    companyDataId: number;
    companyData: Companies.ICompanyData;
    addressId: number;
    address: Addresses.IAddress;
    documents: Documents.IDocument[];
    contacts: Contacts.IContact[];
    businessUnitPersons: Persons.IPerson[];
    status: number;
    distance: string;
    distanceValue: number;
  }

  export class UpdateBusinessUnitRequest implements IUpdateBusinessUnitRequest {
    id: number = 0;
    companyDataId: number = 0;
    companyData: Companies.ICompanyData = new Companies.CompanyData();
    addressId: number = 0;
    address: Addresses.IAddress = new Addresses.Address();
    documents: Documents.IDocument[] = new Array<Documents.IDocument>();
    contacts: Contacts.IContact[] = new Array<Contacts.IContact>();
    businessUnitPersons: Persons.IPerson[] = new Array<Persons.IPerson>();
    status: number = 0;
    distance: string = "";
    distanceValue: number = 0;
  }

  export interface IBusinessUnitPerson {
    businessUnitId: number;
    personId: number;
  }

  export class BusinessUnitPerson implements IBusinessUnitPerson {
    businessUnitId: number = -1;
    personId: number = -1;
  }

  export interface INewBusinessUnitPersonRequest {
    personId: number;
    businessUnitId: number;
    mailAddress: string;
  }

  export class NewBusinessUnitPersonRequest implements INewBusinessUnitPersonRequest {
    personId: number = -1;
    businessUnitId: number = -1;
    mailAddress: string = "";
  }

  export interface IRemoveBusinessUnitPersonRequest {
    personId: number;
    businessUnitId: number;
    userId: number;
  }

  export class RemoveBusinessUnitPersonRequest implements IRemoveBusinessUnitPersonRequest {
    personId: number = -1;
    businessUnitId: number = -1;
    userId: number = -1;
  }

  export interface IBankingInstitution {
    id: number;
    bankCode: string;
    fantasyName: string;

    creationDate: string;
    creationUserId: number;
    updateDate: string;
    updateUserId: number;
    deletionDate: string;
    deletionUserId: number;
  }

  export class BankingInstitution implements IBankingInstitution {
    id: number = 0;
    bankCode: string = "";
    fantasyName: string = "";

    creationDate: string = "";
    creationUserId: number = 0;
    updateDate: string = "";
    updateUserId: number = 0;
    deletionDate: string = "";
    deletionUserId: number = 0;
  }

  export interface IBusinessUnitBankingData {
    id: number;
    businessUnitId: number;
    paymentProvider: number;
    providerAccountId: string;
    bankCode: string;
    bankBranch: string;
    accountNumber: string;
    accountDigit: string;
    walletId: string;
    apiKey: string;
    incomeRange: string;
    accountType: number;
    loginEmail: string;
    documentValue: string;

    creationDate: string;
    creationUserId: number;
    updateDate: string;
    updateUserId: number;
    deletionDate: string;
    deletionUserId: number;
  }

  export class BusinessUnitBankingData implements IBusinessUnitBankingData {
    id: number = 0;
    businessUnitId: number = 0;
    paymentProvider: number = 0;
    providerAccountId: string = "";
    bankCode: string = "";
    bankBranch: string = "";
    accountNumber: string = "";
    accountDigit: string = "";
    walletId: string = "";
    apiKey: string = "";
    incomeRange: string = "";
    accountType: number = 0;
    loginEmail: string = "";
    documentValue: string = "";

    creationDate: string = "";
    creationUserId: number = 0;
    updateDate: string = "";
    updateUserId: number = 0;
    deletionDate: string = "";
    deletionUserId: number = 0;
  }

  export interface IShareBusinessUnit {
    userId: number;
    buName: string | undefined;
    buUrl: string;
    recipient: IContactPerson;
    issuer: IContactPerson;
  }

  export interface IContactPerson {
    name: string;
    email: string;
    mobileNumber: string;
  }

  export class ShareBusinessUnit implements IShareBusinessUnit {
    userId: number = 0;
    buName: string = "";
    buUrl: string = "";
    recipient: IContactPerson = new ContactPerson();
    issuer: IContactPerson = new ContactPerson();
  }

  export class ContactPerson implements IContactPerson {
    name: string = "";
    email: string = "";
    mobileNumber: string = "";
  }

  export class BusinessUnitActivationStatus {
    principalData = new PrincipalData();
    productsAndServices: boolean = false;
    operationParameters: boolean = false;
    bankingData: boolean = false;
    monthly: boolean = false;
  }

  export class PrincipalData {
    address: boolean = false;
    contacts: boolean = false;
  }

  export class BusinessUnitAccountStatus {
    id: string = "";
    commercialInfo: string = "";
    bankAccountInfo: string = "";
    documentation: string = "";
    general: string = "";
  }

  export class PaymentStatistics {
    quantity: number = -1;
    value: number = -1;
    netValue: number = -1;
  }

  export class FinancialTransactionsRequest {
    apiKey: string = "";
    startDate: string = "";
    finishDate: string = "";
    offset: number = 0;
    limit: number = 0;
    order: string = "";
  }

  export interface IFinancialTransaction {
    object: string;
    id: string;
    value: number;
    balance: number;
    type: string;
    date: string;
    description: string;
    paymentId: string;
    transferId: string;
    antecipationId: string;
    billId: string;
    invoiceId: string;
    paymentDunningId: string;
    creditBureauReportId: string;
  }

  export interface IBusinessUnitInstallmentsConfig {
    id: number;
    businessUnitId: number;
    installments: number;
    installmentsWithoutFee: number;

    creationDate: string;
    creationUserId: number;
    updateDate: string;
    updateUserId: number;
    deletionDate: string;
    deletionUserId: number;
  }

  export class BusinessUnitInstallmentsConfig implements IBusinessUnitInstallmentsConfig {
    id: number = 0;
    businessUnitId: number = 0;
    installments: number = 0;
    installmentsWithoutFee: number = 0;

    creationDate: string = "";
    creationUserId: number = 0;
    updateDate: string = "";
    updateUserId: number = 0;
    deletionDate: string = "";
    deletionUserId: number = 0;
  }

  export interface IPixKey {
    id: string;
    key: string;
    type: string;
    status: string;
    date: string;
    canBeDeleted: boolean;
    cannotBeDeletedReason: string;
    qRCode: IQRCode;
    creationDate: string;
    creationUserId: number;
    updateDate: string;
    updateUserId: number;
    deletionDate: string;
    deletionUserId: number;
  }

  export class PixKey implements IPixKey {
    id: string = "";
    key: string = "";
    type: string = "";
    status: string = "";
    date: string = "";
    canBeDeleted: boolean = false;
    cannotBeDeletedReason: string = "";
    qRCode: IQRCode = new QRCode();

    creationDate: string = "";
    creationUserId: number = 0;
    updateDate: string = "";
    updateUserId: number = 0;
    deletionDate: string = "";
    deletionUserId: number = 0;
  }

  export interface IQRCode {
    encodedImage: string;
    payload: string;
  }

  export class QRCode implements IQRCode {
    encodedImage: string = "";
    payload: string = "";
  }

  export interface IProfessionalsPaymentAccountData {
    loginEmail: string;
    documentValue: string;
  }

  export class ProfessionalsPaymentAccountData implements IProfessionalsPaymentAccountData {
    loginEmail: string = "";
    documentValue: string = "";
  }

  export interface IJoinSearchItem {
    id: number;
    fantasyName: string;
    nickname: string;
    imageUrl: string;
    city: string;
    uf: string;
  }

  export interface IJoinRequest {
    id: number;
    personId: number;
    businessUnitId: number;
    status: number;
    requesterName: string;
    requesterNickname: string;
    requesterPhotoUrl: string;
    requesterEmail: string;
    companyFantasyName: string;
    companyNickname: string;
    companyImageUrl: string;
    companyCity: string;
    companyUf: string;
    creationDate: string;
  }

  export interface IBusinessUnitMember {
    personId: number;
    name: string;
    nickname: string;
    photoUrl: string;
    email: string;
  }
}
